module.exports = __webpack_public_path__ + "static/media/detail_0025_f.12d1371e.jpg";